var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.5 7.75C17.5 8.16421 17.1642 8.5 16.75 8.5L1.25 8.5C0.835786 8.5 0.5 8.16421 0.5 7.75C0.5 7.33579 0.835787 7 1.25 7L16.75 7C17.1642 7 17.5 7.33579 17.5 7.75ZM13.875 14.25C13.875 14.6642 13.5392 15 13.125 15L1.25 15C0.835786 15 0.499999 14.6642 0.499999 14.25C0.499999 13.8358 0.835786 13.5 1.25 13.5L13.125 13.5C13.5392 13.5 13.875 13.8358 13.875 14.25ZM10 1.25C10 1.66421 9.66421 2 9.25 2L1.25 2C0.835787 2 0.5 1.66421 0.5 1.25C0.5 0.835786 0.835787 0.499999 1.25 0.499999L9.25 0.5C9.66421 0.5 10 0.835786 10 1.25Z","fill":"black"}));
}

Menu.defaultProps = {"viewBox":"0 0 18 15","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
